import { getAxiosClient } from "../../axios-client";
import {
  ClientUpdateBody, 
  ClientUpdateResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const ClientUpdate = async (
  body: ClientUpdateBody
) => {
  return await axiosClient.ax.put<ClientUpdateResponse>(
    "/Clients/ClientUpdate",
    body
  );
};
